import React from "react";
import classNames from "classnames";
import { isMediumOrSmallScreen } from "utils/constants/onboardingStep";

const ActiveStepIndicator = ({ step }) => {
  const totalSteps = isMediumOrSmallScreen ? 5 : 6;
  const stepsArray = Array.from(
    { length: totalSteps },
    (_, index) => index + 1
  );

  return (
    <div className="step screen-xs:w-full-215 mb-6">
      {stepsArray.map((currentStep) => (
        <div
          key={currentStep}
          className={classNames({
            "active-step": currentStep <= step,
            "inactive-step": currentStep > step,
          })}
        ></div>
      ))}
    </div>
  );
};

export default ActiveStepIndicator;
